import React from "react";
import LanguageSelector from "./LanguageSelector";

const AuthCard = ({ children, className = "", ...props }) => (
  <div
    className={`w-full max-w-md surface-card p-8 mx-4 sm:mx-0 ${className}`}
    {...props}
  >
    <div className="mb-4 flex justify-end">
      <LanguageSelector compact />
    </div>
    {children}
  </div>
);

export default AuthCard;
